import React from 'react';
import {Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from 'reactstrap'
import PropTypes from "prop-types";

export default class DropdownInput extends React.Component{
    state = {}
    defaultItem = {
        id:-99999999999,
        name:'',
        field:'',
    }
    constructor(props) {
        super(props);
        let {title, options} = this.props
        if(!options){
            options =[]
        }
        if(title){
            this.defaultItem = {...this.defaultItem, name:title}
        }else{
            this.defaultItem = options[0]
        }
        let state = this.state
        state.options = options
        state.selectedItem = this.defaultItem
        this.setState(state)
    }


    render() {
        let {selectedItem, options} = this.state
        let {title, onSelect, onReset, className} = this.props
        if(!options){
            options = []
        }
        if(!onSelect){
            onSelect = () => {}
        }
        if(!onReset){
            onReset = () => {}
        }
        return (
            <UncontrolledDropdown group className={className}>
                <Button
                    color="light"
                    className="btn-outline-primary text-primary">
                    {selectedItem.name}
                </Button>
                <DropdownToggle caret color="primary" className="text-center"/>
                <DropdownMenu key={selectedItem.id} className="p-0">
                    {
                        title&&(
                            <React.Fragment>
                                <DropdownItem
                                    className="bg-gradient-gray text-light"
                                    style={{fontSize:'19px'}}
                                    header>
                                    {title}
                                </DropdownItem>
                                <DropdownItem
                                    style={{fontSize:'19px'}}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.setState({selectedItem:this.defaultItem}, () => {
                                            onReset()
                                        })
                                    }}>
                                    Default
                                </DropdownItem>
                                <DropdownItem divider className="p-0 m-0" />
                            </React.Fragment>
                        )
                    }
                    {options.map((item, index)=>{
                        return (
                            <React.Fragment>
                                <DropdownItem
                                    className="bg-gradient-light"
                                    style={{fontSize:'17px'}}
                                    key={item.id}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.setState({selectedItem:item}, () => {
                                            onSelect(item)
                                        })
                                    }}>
                                    {item.name}
                                </DropdownItem>
                            </React.Fragment>
                        )
                    })}
                    {/*<DropdownItem text>*/}
                    {/*    Dropdown Item Text*/}
                    {/*</DropdownItem>*/}
                    {/*<DropdownItem disabled>*/}
                    {/*    Action (disabled)*/}
                    {/*</DropdownItem>*/}
                    {/*<DropdownItem divider />*/}
                    {/*<DropdownItem>*/}
                    {/*    Foo Action*/}
                    {/*</DropdownItem>*/}
                    {/*<DropdownItem>*/}
                    {/*    Bar Action*/}
                    {/*</DropdownItem>*/}
                    {/*<DropdownItem>*/}
                    {/*    Quo Action*/}
                    {/*</DropdownItem>*/}
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    }
}
DropdownInput.propTypes = {
    title:PropTypes.string,
    options:PropTypes.array,
    onSelect:PropTypes.func,
    onReset:PropTypes.func,
    className:PropTypes.string,
}